import React from 'react';
import './Question.scss';

const Question = ({ questionData, caseData, onAnswer, currentPlayerId, activeRespondentId, isDefi, onBuzz, hasBuzzed, canAnswer: canAnswerProp }) => {
    // Sécurité : si aucune donnée n'est passée, on n'affiche rien
    if (!questionData || !caseData) return null;

    // Sécurité supplémentaire : s'assurer que type existe bien avant d'utiliser charAt
    const typeDeCase = caseData.type || 'Inconnu';
    const titreCase = caseData.label || typeDeCase.charAt(0).toUpperCase() + typeDeCase.slice(1);
    const titreAffiche = titreCase === 'Maison' ? 'Maison (duel)' : titreCase;

    // Récupération des options envoyées (mélangées à chaque tirage de question)
    let optionsArray = [];
    try {
        optionsArray = typeof questionData.options === 'string'
            ? JSON.parse(questionData.options)
            : (questionData.options || []);
    } catch (error) {
        console.error("Erreur de formatage des options :", error);
        optionsArray = ["Erreur de chargement des options"];
    }

    const canAnswer = canAnswerProp !== undefined 
        ? canAnswerProp 
        : (currentPlayerId != null && activeRespondentId != null && String(currentPlayerId) === String(activeRespondentId));

    return (
        <div className="modal-overlay">
            <div className="modal-content question-modal">

                {/* En-tête */}
                <div className="modal-header">
                    <h3 className="modal-title">
                        {titreAffiche} <span className="points-badge">{caseData.points || 0} pts</span>
                    </h3>
                    <span className="theme-badge">{questionData.categorie}</span>
                </div>

                {/* Image */}
                {questionData.image_url && (
                    <div className="image-container">
                        <img
                            src={(() => {
                                let url = String(questionData.image_url).trim();
                                if (url.startsWith('http://') || url.startsWith('https://')) return url;
                                const fileName = url.split('/').pop();
                                const baseName = fileName.replace(/\.svg\.webp$/i, '').replace(/\.(png|jpg|jpeg|svg|webp)$/i, '');
                                return `/assets/${baseName}.webp`;
                            })()}
                            alt="Illustration de la question"
                            className="question-image"
                        />
                    </div>
                )}

                {/* Texte de la question */}
                <div className="question-text">
                    {questionData.question}
                </div>

                {/* Boutons ou Buzzer */}
                {isDefi && !hasBuzzed ? (
                    <div className="buzzer-container-lobby">
                        <button className="btn-huge-buzzer" onClick={onBuzz}>
                            ⚡ BUZZ ! ⚡
                        </button>
                        <p className="buzzer-help">Soyez le plus rapide à buzzer pour répondre !</p>
                    </div>
                ) : (
                    <>
                        <div className="options-container">
                            {/* ON UTILISE optionsArray ICI */}
                            {optionsArray.map((option, index) => {
                                return (
                                    <button
                                        key={index}
                                        className="option-button"
                                        onClick={() => canAnswer && onAnswer(option)}
                                        disabled={!canAnswer}
                                    >
                                        <span style={{ marginRight: '10px', fontWeight: '900', color: '#3b82f6' }}>
                                            {String.fromCharCode(65 + index)})
                                        </span>
                                        {option}
                                    </button>
                                );
                            })}
                        </div>
                        <div className="answering-status-message">
                            {canAnswer
                                ? "👉 C'est à votre tour de répondre !"
                                : "⏳ En attente de la réponse du joueur actif..."}
                        </div>
                    </>
                )}

                {/* ID */}
                <div className="question-id">
                    ID : {questionData.id}
                </div>

            </div>
        </div>
    );
};

export default Question;